import Header from '../components/Header';
import Footer from '../components/Footer';
import { FileText, AlertCircle } from 'lucide-react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-dark-bg">
      <Header />
      <main className="py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <article className="bg-dark-card border-2 border-gray-800 rounded-2xl p-8 md:p-12">
            <div className="flex items-center mb-6">
              <FileText className="w-8 h-8 text-toxic-green mr-4" />
              <h1 className="text-4xl md:text-5xl font-bold text-white">
                Conditions Générales d'Utilisation
              </h1>
            </div>

            <div className="prose prose-invert max-w-none">
              <p className="text-gray-400 mb-8 text-sm">
                Dernière mise à jour : 26 novembre 2025
              </p>

              <p className="text-gray-300 mb-6 leading-relaxed">
                Les présentes Conditions Générales d'Utilisation (ci-après "CGU") régissent l'utilisation du site web hexabetconnect.com (ci-après "le Site") exploité par Hexabet Connect. En accédant et en utilisant ce Site, vous acceptez d'être lié par ces CGU. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser le Site.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                1. Acceptation des Conditions
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                En accédant au Site, vous reconnaissez avoir lu, compris et accepté d'être lié par ces CGU, ainsi que par notre Politique de Confidentialité et notre Politique des Cookies. Si vous n'acceptez pas ces conditions, vous devez immédiatement cesser d'utiliser le Site.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                2. Description du Service
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Hexabet Connect est un site indépendant de comparaison et d'information sur les plateformes de paris en ligne en France. Nous fournissons des informations, des guides, des actualités, et des avis sur les opérateurs de paris agréés. Nous ne sommes pas un opérateur de paris et ne proposons pas de services de paris directement.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous sommes un site d'information et de comparaison. Tous les paris sont effectués directement sur les plateformes des opérateurs agréés, et non sur notre site. Nous ne sommes pas responsables des transactions effectuées sur ces plateformes tierces.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                3. Liens d'Affiliation
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Certains liens présents sur notre Site sont des liens d'affiliation. Cela signifie que nous pouvons recevoir une commission si vous cliquez sur ces liens et vous inscrivez sur la plateforme concernée. Cette commission n'affecte jamais nos opinions, nos analyses, ou nos évaluations. Nous restons indépendants et objectifs dans nos recommandations.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les liens d'affiliation sont clairement identifiés lorsque cela est possible. En utilisant ces liens, vous acceptez que nous puissions recevoir une commission, sans que cela n'affecte le prix que vous payez ou les conditions que vous recevez de la plateforme.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                4. Utilisation du Site
              </h2>
              <h3 className="text-2xl font-bold mt-8 mb-4 text-white">
                Utilisation Autorisée
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Vous êtes autorisé à utiliser le Site pour consulter les informations, lire les guides et actualités, et comparer les plateformes de paris. Vous pouvez partager les liens vers nos pages sur les réseaux sociaux ou via d'autres moyens de communication, dans le respect de nos droits de propriété intellectuelle.
              </p>
              <h3 className="text-2xl font-bold mt-8 mb-4 text-white">
                Utilisations Interdites
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Il est strictement interdit de :
              </p>
              <ul className="list-disc list-inside space-y-3 text-gray-300 mb-6 ml-4">
                <li>Utiliser le Site à des fins illégales ou non autorisées</li>
                <li>Reproduire, copier, ou dupliquer le contenu sans autorisation</li>
                <li>Modifier, adapter, ou créer des œuvres dérivées à partir de notre contenu</li>
                <li>Tenter d'accéder de manière non autorisée à nos systèmes ou serveurs</li>
                <li>Utiliser des robots, scripts, ou autres moyens automatisés pour extraire des données</li>
                <li>Transmettre des virus, logiciels malveillants, ou code nuisible</li>
                <li>Harceler, menacer, ou nuire à d'autres utilisateurs ou à notre personnel</li>
                <li>Utiliser le Site si vous avez moins de 18 ans</li>
              </ul>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                5. Propriété Intellectuelle
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Tout le contenu du Site, incluant mais sans s'y limiter, les textes, graphiques, logos, icônes, images, clips audio, téléchargements numériques, et compilations de données, est la propriété d'Hexabet Connect ou de ses fournisseurs de contenu et est protégé par les lois françaises et internationales sur le droit d'auteur.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Vous ne pouvez pas reproduire, distribuer, modifier, créer des œuvres dérivées, afficher publiquement, représenter publiquement, republier, télécharger, stocker ou transmettre aucun matériel de notre Site sans notre autorisation écrite préalable.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                6. Exactitude des Informations
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous nous efforçons de fournir des informations exactes et à jour sur notre Site. Cependant, nous ne garantissons pas l'exactitude, l'exhaustivité, ou l'actualité de toutes les informations. Les informations sur les bonus, les cotes, et les conditions des plateformes peuvent changer sans préavis.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous vous recommandons de toujours vérifier les informations directement sur les sites des plateformes de paris avant de prendre une décision. Nous ne sommes pas responsables des erreurs ou omissions dans les informations que nous fournissons.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                7. Limitation de Responsabilité
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Dans la mesure permise par la loi, Hexabet Connect et ses dirigeants, employés, agents, et partenaires ne seront pas responsables de tout dommage direct, indirect, accessoire, spécial, consécutif ou punitif résultant de votre utilisation ou de votre incapacité à utiliser le Site.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous ne sommes pas responsables des transactions effectuées sur les plateformes de paris tierces. Toute transaction est entre vous et la plateforme concernée, et nous ne sommes pas partie à ces transactions. Nous ne sommes pas responsables des pertes financières résultant de vos paris.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Le Site est fourni "tel quel" sans garantie d'aucune sorte, expresse ou implicite. Nous ne garantissons pas que le Site sera ininterrompu, sécurisé, ou exempt d'erreurs.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                8. Liens Vers des Sites Tiers
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Notre Site contient des liens vers des sites web de tiers, notamment les plateformes de paris. Ces liens sont fournis pour votre commodité uniquement. Nous n'avons aucun contrôle sur le contenu de ces sites et n'assumons aucune responsabilité pour eux.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                L'inclusion d'un lien ne constitue pas une approbation du site lié. Vous utilisez ces liens à vos propres risques. Nous vous recommandons de lire les conditions générales et les politiques de confidentialité de tout site tiers que vous visitez.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                9. Jeu Responsable
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les paris en ligne peuvent être addictifs et doivent être pratiqués de manière responsable. Nous encourageons fortement le jeu responsable et vous rappelons que les paris doivent rester un loisir, pas une source de revenus ou un moyen de résoudre des problèmes financiers.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Si vous pensez avoir un problème de jeu, nous vous encourageons à consulter notre page Jeu Responsable et à contacter les services d'aide disponibles. Les paris sont interdits aux mineurs de moins de 18 ans.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                10. Modifications des CGU
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous nous réservons le droit de modifier ces CGU à tout moment. Les modifications entreront en vigueur dès leur publication sur le Site. Il est de votre responsabilité de consulter régulièrement ces CGU pour prendre connaissance des modifications.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Votre utilisation continue du Site après la publication des modifications constitue votre acceptation des nouvelles conditions.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                11. Résiliation
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous nous réservons le droit de suspendre ou de résilier votre accès au Site à tout moment, sans préavis, pour quelque raison que ce soit, notamment en cas de violation de ces CGU.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                12. Droit Applicable et Juridiction
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Ces CGU sont régies par le droit français. Tout litige relatif à ces CGU sera soumis à la compétence exclusive des tribunaux français.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                13. Contact
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Pour toute question concernant ces CGU, contactez-nous :
              </p>
              <div className="bg-toxic-green/10 border border-toxic-green/30 rounded-xl p-6 mt-6">
                <p className="text-gray-300 mb-2"><strong>Email :</strong> info@hexabetconnect.com</p>
                <p className="text-gray-300 mb-2"><strong>Téléphone :</strong> +33 4 21 73 98 33</p>
                <p className="text-gray-300"><strong>Adresse :</strong> Paris, France</p>
              </div>
            </div>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;

